import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { clone as s } from "../core/lang.js";
import { property as r } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as t } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as o } from "../core/accessorSupport/decorators/subclass.js";
import i from "./Renderer.js";
import { VisualVariablesMixin as l } from "./mixins/VisualVariablesMixin.js";
import { rendererSymbolProperty as a } from "./support/commonProperties.js";

var _c;

var n = _c = /*#__PURE__*/function (_l) {
  _inherits(c, _l);

  var _super = _createSuper(c);

  function c(e) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, e), _this.description = null, _this.label = null, _this.symbol = null, _this.type = "simple";
    return _this;
  }

  _createClass(c, [{
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, s) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([this.collectSymbolFields(e, s), this.collectVVRequiredFields(e, s)]);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function collectRequiredFields(_x, _x2) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "collectSymbolFields",
    value: function () {
      var _collectSymbolFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, s) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all(this.getSymbols().map(function (r) {
                  return r.collectRequiredFields(e, s);
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function collectSymbolFields(_x3, _x4) {
        return _collectSymbolFields.apply(this, arguments);
      }

      return collectSymbolFields;
    }()
  }, {
    key: "getSymbol",
    value: function getSymbol(e, s) {
      return this.symbol;
    }
  }, {
    key: "getSymbolAsync",
    value: function () {
      var _getSymbolAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, s) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.symbol);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSymbolAsync(_x5, _x6) {
        return _getSymbolAsync.apply(this, arguments);
      }

      return getSymbolAsync;
    }()
  }, {
    key: "getSymbols",
    value: function getSymbols() {
      return this.symbol ? [this.symbol] : [];
    }
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return this.visualVariables && this.visualVariables.reduce(function (e, s) {
        return e + s.getAttributeHash();
      }, "");
    }
  }, {
    key: "getMeshHash",
    value: function getMeshHash() {
      return this.getSymbols().reduce(function (e, s) {
        return e + JSON.stringify(s);
      }, "");
    }
  }, {
    key: "arcadeRequired",
    get: function get() {
      return this.arcadeRequiredForVisualVariables;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _c({
        description: this.description,
        label: this.label,
        symbol: this.symbol && this.symbol.clone(),
        visualVariables: s(this.visualVariables),
        authoringInfo: this.authoringInfo && this.authoringInfo.clone()
      });
    }
  }]);

  return c;
}(l(i));

e([r({
  type: String,
  json: {
    write: !0
  }
})], n.prototype, "description", void 0), e([r({
  type: String,
  json: {
    write: !0
  }
})], n.prototype, "label", void 0), e([r(a)], n.prototype, "symbol", void 0), e([t({
  simple: "simple"
})], n.prototype, "type", void 0), n = _c = e([o("esri.renderers.SimpleRenderer")], n);
var p = n;
export { p as default };